import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MagnificationService, NavigationService, TextSelectionService, ToolbarService} from '@syncfusion/ej2-angular-pdfviewer';

@Component({
  selector: 'app-modal-view-file',
  templateUrl: './modal-view-file.component.html',
  styleUrls: ['./modal-view-file.component.scss'],
  providers: [MagnificationService, ToolbarService, NavigationService, TextSelectionService]
})
export class ModalViewFileComponent implements OnInit {
  public service = 'https://pdf.apispot.xyz/api/pdfviewer';
  public toolbarSettings = { showTooltip: true, toolbarItems: 'DownloadOption PageNavigationTool MagnificationTool PanTool SelectionTool' };
  @Input() isVisibleModal: boolean;
  @Input() fileUrl: string;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closed.emit(true);
  }
}
